import { Tooltip } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import type React from "react";
import type { FC, ReactNode } from "react";

interface LongContentCellProps {
  maxWidth?: string | number;
  className?: string;
  tooltipClassName?: string;
  tooltipWidth?: string | number;
  tooltip?: ReactNode;
}

const LongContentCell: FC<React.PropsWithChildren<LongContentCellProps>> = ({
  maxWidth,
  tooltip,
  tooltipClassName,
  tooltipWidth,
  children,
}) => (
  <Tooltip
    isDisabled={!tooltip}
    label={
      <div className={tooltipClassName} style={{ width: tooltipWidth }}>
        {tooltip}
      </div>
    }
  >
    <div className="truncate" style={{ maxWidth }}>
      {children}
    </div>
  </Tooltip>
);

export default observer(LongContentCell);
